import { Select } from 'antd';

interface Props {
  placeholder: string;
  options: {
    value: string;
    label: string;
  }[];
  onChange?: (value: string) => void;
  value?: string;
}

export function SearchableSelect({ placeholder, options, onChange, value }: Readonly<Props>) {
  return (
    <Select
      showSearch
      style={{ width: '100%' }}
      placeholder={placeholder}
      optionFilterProp="label"
      filterSort={(optionA, optionB) =>
        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
      }
      options={options}
      onChange={onChange}
      getPopupContainer={triggerNode => triggerNode.parentNode as HTMLElement}
      value={value}
    />
  );
}
